import { useCallback, useEffect, useState } from "react";

export const useFetch = (initurl) => {
    const [data, setData] = useState();
    const [isLoading, setLoading] = useState(true);
    const [isError, setError] = useState(false);
    const [Url, setUrl] = useState(initurl);

    const doFetch = useCallback(() => {
        (async () => {
            try {
                const res = await fetch(Url,
                    {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }
                );
                const data = await res.json();
                console.log(data);
                setData(data);
            } catch (err) {
                console.error(err);
                setError(true);
            } finally {
                setLoading(false);
            }
        })()
    }, [Url]);
    return {doFetch, data, isLoading, isError, setUrl};
};

export const usePost = (url) => {
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);
    const [isSuccess, setSuccess] = useState(false);
    const [message, setMessage] = useState("");

    const doPost = useCallback(
        (body) => {
            (async () => {
                if (!url) { return; }
                if (!body) { return; }
                try {
                    setLoading(true);
                    setSuccess(false);
                    setError(false);
                    setMessage("");
                    const res = await fetch(url,
                        {
                            method: "PUT",
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: body
                        }
                    );
                    if (res.status == 200 || res.status == 201) {
                        setSuccess(true);
                    } else {
                        setError(true);
                        setMessage(res.status + " " + res.statusText);
                    }
                } catch (err) {
                    console.error(err);
                    setError(true);
                } finally {
                    setLoading(false);
                }
            })()
        }, [url]
    )
    
    return { doPost, isSuccess, isLoading, isError, message };

};


export const useDelete = (url) => {
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);
    const [isSuccess, setSuccess] = useState(false);
    const [message, setMessage] = useState("");

         const doDelete = useCallback(
        (body) => {
            (async () => {
                if (!url) { return; }
                if (!body) { return; }
                try {
                    setLoading(true);
                    setSuccess(false);
                    setError(false);
                    setMessage("");
                    const res = await fetch(url,
                        {
                            method: "DELETE",
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: body
                        }
                    );
                    if (res.status == 200 || res.status == 201) {
                        setSuccess(true);
                    } else {
                        setError(true);
                        setMessage(res.status + " " + res.statusText);
                    }
                } catch (err) {
                    console.error(err);
                    setError(true);
                } finally {
                    setLoading(false);
                }
            })()
        }, [url]
    )
    
    return { doDelete, isSuccess, isLoading, isError, message };

};